export default __webpack_public_path__ + "static/media/seein3d.41b8cc56.svg";